import CasinoCarousel from "@/components/Casino/CasinoCarousel.vue";
export default {
    name: "CasinoHeader",
    components: {
        CasinoCarousel // Avatar,
        // AvatarFallback,
        // AvatarImage,
    },
    props: {
        games: {
            type: Array,
            required: true,
        },
        isLoading: {
            type: Boolean,
            required: true,
        },
    },
};
